// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { TipoArticuloProps } from '../../../interfaces/tipoArticulo.ts'

const query = gql`
  query LISTADO($limit: Int! = 10) {
    tipoArticuloListado(limit: $limit) {
      pageInfo {
        totalDocs
      }
      docs {
        _id
        codigo
        orden
        descripcion
      }
    }
  }
`

/**
 * Listamos las unidades de medida simples sin el uso de filtros
 * @param limit
 */
export const apiTipoArticuloSimpleListado = async (limit: number): Promise<TipoArticuloProps[]> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)

    const data: any = await client.request(query, { limit })
    return data.tipoArticuloListado?.docs || []
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
